import * as React from 'react';
import { Text, Link, Label } from '../../CommonUI';
import { GeneralSettings} from '../../Model';
import '../../Assets/styles/integration-key.css';
import { Flex, Box } from '../../CommonUI/Layout';
import * as images from '../../Assets/images/svg';

const integrationKeyUrlPlaceholder = ':platform';

interface IntegrationKeyProps {
    onChange: (settings: GeneralSettings) => void;
    settings: GeneralSettings;
    source: string;
    padding?: number;
    tierName: string;
}

export class IntegrationKey extends React.Component<IntegrationKeyProps> {
    constructor(props: IntegrationKeyProps) {
        super(props);
        this.state = { isWorking: false };
        this.onIntegrationKeyChange = this.onIntegrationKeyChange.bind(this);
        this.validate = this.validate.bind(this);
        this.getIntegrationKeyLink = this.getIntegrationKeyLink.bind(this);
    }

    public onIntegrationKeyChange(event: React.ChangeEvent<HTMLInputElement>) {
        this.props.onChange({ key: event.target.value });
    }

    public validate(value: string) {
        return value && value.length !== 16 ? false : true;
    }

    public getIntegrationKeyLink(source: string) {
        const link = process.env.REACT_APP_GetIntegrationKeyUrl;
        if (link) {
            return link.replace(integrationKeyUrlPlaceholder, source.toLowerCase());
        }
        return '';
    }

    public render() {
        const { settings, source, tierName } = this.props;
        const { key } = settings;
        let successIntegration;
        if (this.validate(key || 'incorrect')) {
            successIntegration = (
                <Flex flexDirection={'row'}  alignItems="center">
                    <Box width="auto" mr={10} ml={16} mt="0px">
                        <images.checked/>
                    </Box>
                    <Label label={'Containers.pluginInstalledCorrectly'} className="success-text" />
                </Flex>
            );
        }
        return (
                    <Box>
                        <Flex
                            flexDirection="row"
                            alignItems="flex-end"
                            justifyContent="space-around"
                        >
                            <Text
                                id="integration-key"
                                label="Containers.integrationKey"
                                value={key}
                                onChangeEvent={this.onIntegrationKeyChange}
                                validationError="Containers.interationKeyNotValid"
                                validate={this.validate}
                            >
                                {successIntegration}
                            </Text>
                        </Flex>
                        <Link
                            label="general.getKey"
                            href={this.getIntegrationKeyLink(source)}
                            track={{
                                placement: 'Under integration key TextBox',
                                target: 'Integration page in business app',
                                name: 'get-key-link',
                                source,
                                tierName,
                            }}
                        />
                    </Box>
        );
    }
}
